import React from 'react';
import {Container} from '@material-ui/core';
import {FirebaseContext} from '../../Firebase';
import {Button, TextField} from '@material-ui/core';
import ReactGoogleSlides from 'react-google-slides';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import AnalyseIm from '../../../images/analysevis.jpg';

const Session15 = () => {
  const firebase = React.useContext(FirebaseContext);
  const group = firebase.userData.group;
  const [scr, setScr] = React.useState(0);
  const [CR, setCR] = React.useState(false);
  const [response, setResponse] = React.useState('');
  const [respResp1, setRespResp1] = React.useState('');
  return (
    <div>
      <Container
        style={{
          backgroundColor: 'lightblue',
          padding: '10px',
          minHeight: '270px',
        }}
      >
        {/* SCREENS INTRO ALL GROUP*/}
        {scr === 0 && (
          <div>
            <h3>Bienvenue dans cette nouvelle session !</h3>
            <p>
              Les semaines passées, tu as pu faire le tour de l’altruisme en
              classe, dans les associations, et à travers le monde.
            </p>
            <p>Et si on se demandait comment on peut agir, nous ?</p>
            <p>
              Clique sur le bouton continuer une fois que tu as bien compris
              pour continuer.
            </p>
          </div>
        )}
        {scr === 1 && (
          <div style={{textAlign: 'center', width: '100%'}}>
            <ReactGoogleSlides
              width={'100%'}
              height={480}
              slidesLink="https://docs.google.com/presentation/d/1ewQ4bZG-KTv4Wc64DQ0l_Ut2_MMdW1MlvxnxI21Rej4"
              position={0}
              showControls
            />
            <br />
            <FormControl component="fieldset">
              <FormLabel component="legend">
                Le « pa » dans le modèle OPaLE qui représente quel mot :
              </FormLabel>
              <RadioGroup
                aria-label="team"
                defaultValue=""
                name="radio-buttons-group-team"
                onChange={(e) => {
                  setCR(true);
                  setResponse(e.target.value);
                }}
              >
                <FormControlLabel
                  value="partie"
                  control={<Radio />}
                  label="Partir"
                />
                <FormControlLabel
                  value="paturage"
                  control={<Radio />}
                  label="Pâturage"
                />
                <FormControlLabel
                  value="parler"
                  control={<Radio />}
                  label="Parler"
                />
              </RadioGroup>
            </FormControl>
          </div>
        )}
        {/* SCREENS CONTROL*/}
        {group.toString() === 'control' && scr === 2 && (
          <div>
            <p>
              Aujourd’hui, nous allons te montrer une grande scène dans laquelle
              il se passe beaucoup de choses. Ton objectif est de prendre ton
              temps pour la regarder et, ensuite, expliquer ce que tu y vois.
            </p>
          </div>
        )}
        {group.toString() === 'control' && scr === 3 && (
          <div>
            <p>Voici l’image à observer. Prends ton temps.</p>
            <img
              src={AnalyseIm}
              alt="ImageAnalyse"
              style={{width: '45%', marginLeft: '20%'}}
            />
            <p>
              Maintenant, à toi de faire un résumé en deux ou trois phrases de
              ce qui se trouve sur cette image :
            </p>
            <TextField
              multiline
              fullWidth
              rows="4"
              id="regles"
              label="Résumé"
              variant="outlined"
              value={respResp1}
              onChange={(e) => {
                setRespResp1(e.target.value);
              }}
            />
            <p>Quand tu as terminé, clique sur le bouton ci-dessous.</p>
          </div>
        )}
        {group.toString() === 'control' && scr === 4 && (
          <div>
            <p>
              Souviens-toi bien de comment tu as observé cette image pour la
              prochaine fois.
            </p>
            <p>
              Nous avons terminé pour aujourd’hui. N’oublie pas de te
              reconnecter dans quelques jours pour notre prochaine séance.
            </p>
            <p>Merci pour ta participation !</p>
            <p>Clique sur le bouton ci-dessous pour quitter la séance.</p>
          </div>
        )}
        {/* SCREENS TEST*/}
        {(group.toString() === 'test_a' ||
          group.toString() === 'test_b' ||
          group.toString() === 'test_c') &&
          scr === 2 && (
            <div>
              <p>
                Ton engagement bénévole va bientôt prendre fin. Ella sera la
                jeune bénévole qui prendra ta place dans l’association pour
                continuer les actions que tu as pu mener ces dernières semaines.
              </p>
              <p>
                Ta mission sera d’expliquer à Ella ce que tu as fait pendant ces
                séances pour qu’elle comprenne mieux son rôle.
              </p>
              <p>Allons-y !</p>
            </div>
          )}
        {(group.toString() === 'test_a' ||
          group.toString() === 'test_b' ||
          group.toString() === 'test_c') &&
          scr === 3 && (
            <div>
              <p>
                Aujourd’hui, tu vas commencer par faire la synthèse de tout ce
                que tu as fait jusqu’ici.
              </p>
              <p>
                La synthèse, c’est un peu comme le résumé. Tu vas donc pouvoir
                faire la liste des actions menées pendant ces semaines de
                bénévolat et les écrire ci-dessous :
              </p>
              <TextField
                multiline
                fullWidth
                rows="4"
                label="Résumé"
                variant="outlined"
                value={respResp1}
                onChange={(e) => {
                  setRespResp1(e.target.value);
                }}
              />
              <p>
                Ella pourra voir cette liste pour commencer à préparer son rôle
                de bénévole.
              </p>
              <p>Quand tu as terminé, clique sur le bouton ci-dessous.</p>
            </div>
          )}
        {(group.toString() === 'test_a' ||
          group.toString() === 'test_b' ||
          group.toString() === 'test_c') &&
          scr === 4 && (
            <div>
              <p>
                Nous avons terminé pour aujourd’hui. N’oublie pas de te
                connecter dans quelques jours pour la prochaine, et dernière,
                séance.
              </p>
              <p>Merci pour ta participation !</p>
              <p>Clique sur le bouton ci-dessous pour quitter la séance.</p>
            </div>
          )}
      </Container>
      {/* BUTTON*/}
      <Button
        style={{display: 'block', margin: 'auto'}}
        disabled={scr === 1 && !CR}
        variant="contained"
        color="primary"
        onClick={() => {
          if (scr === 3) {
            // save TEST DATA
            let now = new Date();
            firebase
              .databehav(firebase.userData.pseudo)
              .collection('session15')
              .add({
                date: now,
                response: response,
                resume: respResp1,
              })
              .catch((error) => {
                console.log(error);
              });
          }
          if (scr === 4) {
            firebase.signoutUser();
          } else {
            setScr(scr + 1);
          }
        }}
      >
        Continuer
      </Button>
    </div>
  );
};
export default Session15;
